<template>
  <div class="component albums-list">
    <div class="album" v-for="item in items" :key="item.id">
      <router-link :to="{ name: 'album-view', params: { albumId: item.id } }">
        <ImgLoader :src="item._cover_thumbnail" alt=""></ImgLoader>
        <div class="title">{{ item.title }}</div>
        <div class="date" v-if="item.event_date">{{ $moment(item.event_date).format($FORMAT_DATETIME.DATE) }}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
  import ImgLoader from '../../components/ImgLoader.vue'

  export default {
    name: 'AlbumList',
    props: {
      items: {
        type: Array,
        default: () => []
      }
    },
    components: {
      ImgLoader
    }
  }
</script>

<style lang="scss">
  .component.albums-list {
    display: flex;
    flex-wrap: wrap;
    .album {
      position: relative;
      width: 50%;
      min-height: 100px;
      font-family: $font-title;
      overflow: hidden;
      border: 1px solid transparent;
      transition: all .6s;
      &:hover img {
        transform: scale(1.1);
      }
      @media only screen
      and (max-width: 800px){
        width: 100%;
      }
      a {
        height: 100%;
        display: block;
        transition: all .8s;
        color: $color-font-main;
        &:hover {
          opacity: .8;
        }
        img {
          transition: all .6s;
          @media only screen
          and (max-width: 800px){
            width: 100%;
          }
        }
        .title {
          position: absolute;
          bottom: 0;
          padding: 20px;
          margin: 20px;
          font-size: 35px;
          text-transform: uppercase;
          background-color: rgba(0, 0, 0, .5);
          @media only screen
          and (max-width: 500px){
            font-size: 20px;
            padding: 10px;
          }
          @include media_mobile_mini {
            font-size: 18px;
            padding: 8px;
          }
        }
        .date {
          font-size: 20px;
          position: absolute;
          top: 0;
          right: 0;
          padding: 10px;
          margin: 10px;
          background-color: rgba(0, 0, 0, .5);
          @media only screen
          and (max-width: 500px){
            font-size: 14px;
            padding: 8px;
          }
          @include media_mobile_mini {
            font-size: 15px;
            padding: 5px;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/gallery/AlbumList.vue